import { EmptyState } from '@/components/ui/EmptyState';
import { Alert } from '@/components/ui/Alert';
import { usePromotions } from '../api';
import { PromotionCard } from './PromotionCard';

interface PromotionListProps {
  featuredOnly?: boolean;
  /** How many skeletons to show while loading. Match the usual result count. */
  skeletonCount?: number;
  emptyMessage?: string;
}

export function PromotionList({
  featuredOnly = false,
  skeletonCount = 3,
  emptyMessage = 'Şu anda aktif promosyon yok.',
}: PromotionListProps) {
  const { data: promotions, isLoading, isError } = usePromotions(featuredOnly);

  if (isError) {
    return <Alert tone="error">Promosyonlar yüklenemedi. Lütfen sayfayı yenileyin.</Alert>;
  }

  if (isLoading) {
    return (
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" aria-hidden>
        {Array.from({ length: skeletonCount }, (_, i) => (
          <div
            key={i}
            className="h-64 animate-pulse rounded-[var(--radius-card)] border border-surface-800 bg-surface-900"
          />
        ))}
      </div>
    );
  }

  if (!promotions || promotions.length === 0) {
    return (
      <EmptyState
        title={emptyMessage}
        description="Yeni bonuslar ve kampanyalar yayına alındığında burada görünecek."
      />
    );
  }

  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {promotions.map((promotion) => (
        <PromotionCard key={promotion.id} promotion={promotion} />
      ))}
    </div>
  );
}
